import { GemSpec, GenericGraphProcessType, CommonGraph } from '@common/types';

import { getGemSpec } from './getGemSpec';
import { getGemTypeByProcess } from './getGemTypeByProcess';

export function getGemSpecByProcess<G extends CommonGraph>(process: GenericGraphProcessType<G>, gemSpecs: GemSpec[]) {
  const gemType = getGemTypeByProcess(process);
  return getGemSpec(gemSpecs, gemType);
}
